import moment from 'moment';
import chartingService from '../../../../../core/services/Technical/Charting';
import { getIndicatorHistoricalPeriod, setMultiplierByCode } from '../helper';

var prevTicker = '';
var prevPeriod = '';
var isLoop = true;
var object = {
  t: [],
  h: [],
  l: [],
};

export const BUSDCode = 'BUSD';

export const BUSD = PineJS => ({
  name: 'BU/SD',
  metainfo: {
    _metainfoVersion: 51,
    id: 'BUSD@tv-basicstudies-1',
    name: 'FiinTrade - BU/SD',
    description: 'FiinTrade - BU/SD',
    shortDescription: 'FiinTrade - BU/SD',
    is_hidden_study: false,
    is_price_study: false,
    isCustomIndicator: true,
    format: {
      type: 'price',
      precision: 2,
      indicator: BUSDCode,
    },
    plots: [{ id: 'plot_0', type: 'line' }, { id: 'plot_1', type: 'line' }],
    defaults: {
      styles: {
        plot_0: {
          linestyle: 0,
          linewidth: 1,
          plottype: 4,
          trackPrice: false,
          transparency: 50,
          visible: true,
          color: '#43A77D',
        },
        plot_1: {
          linestyle: 0,
          linewidth: 1,
          plottype: 4,
          trackPrice: false,
          transparency: 50,
          visible: true,
          color: '#E84855',
        },
      },
      precision: 1,
      inputs: {},
    },
    styles: {
      plot_0: { title: 'BU', histogramBase: 0, joinPoints: true },
      plot_1: { title: 'SD', histogramBase: 0, joinPoints: true },
    },
    inputs: [],
  },
  constructor: function() {
    this.init = function(context, inputCallback) {
      this._context = context;
      this._input = inputCallback;
      var period = PineJS.Std.period(this._context);
      var ticker = PineJS.Std.ticker(this._context);
      var symbol = 'INDICATOR:BUSD:' + ticker;
      this._context.new_sym(symbol, period);
      if (period.includes('W') || period.includes('M')) {
        var historicalSymbol = 'INDICATOR:BUSD:' + ticker;
        this._context.new_sym(
          historicalSymbol,
          getIndicatorHistoricalPeriod(period),
        );
      }
      isLoop = true;
      object = {
        t: [],
        h: [],
        l: [],
      };
      if (prevPeriod !== period || prevTicker !== ticker) {
        prevPeriod = period;
        prevTicker = ticker;
      }
    };

    this.main = function(ctx, inputs) {
      this._context = ctx;
      this._input = inputs;
      this._context.select_sym(1);
      var period = PineJS.Std.period(this._context);
      var time = PineJS.Std.time(this._context, period);

      if (period.includes('W') || period.includes('M')) {
        this._context.select_sym(2);
        var timeHistory = this._context.new_var(
          PineJS.Std.time(this._context, getIndicatorHistoricalPeriod(period)),
        );
        var buyUpHistory = this._context.new_var(
          PineJS.Std.high(this._context),
        );
        var sellDownHistory = this._context.new_var(
          PineJS.Std.low(this._context),
        );

        const timeHistoryCurrent = timeHistory.get(0);
        if (
          isLoop &&
          !PineJS.Std.na(timeHistoryCurrent) &&
          !object.t.includes(timeHistoryCurrent)
        ) {
          object.t.push(timeHistoryCurrent);
          object.h.push(buyUpHistory.get(0));
          object.l.push(sellDownHistory.get(0));
        }

        if (!PineJS.Std.na(time)) {
          this._context.select_sym(2);
          var lengthHistory = PineJS.Std.n(this._context);
          if (lengthHistory === object.t.length && isLoop) {
            isLoop = false;
          }

          var sumBuyUp = 0;
          var sumSellDown = 0;
          var count = 0;
          var indexOfTime = object.t.findIndex(val => val === time);
          var weekOfTime = moment(new Date(time)).week();
          var monthOfTime = new Date(time).getMonth() + 1;
          var yearOfTime = new Date(time).getFullYear();
          for (var x = indexOfTime; x < lengthHistory && x >= 0; x++) {
            if (period.includes('M')) {
              const month = new Date(object.t[x]).getMonth() + 1;
              const year = new Date(object.t[x]).getFullYear();
              switch (period) {
                case '12M': {
                  if (yearOfTime === year) {
                    sumBuyUp += object.h[x] || 0;
                    sumSellDown += object.l[x] || 0;
                  } else {
                    count++;
                  }
                  break;
                }
                case '3M': {
                  if (monthOfTime - 3 < month && yearOfTime === year) {
                    sumBuyUp += object.h[x] || 0;
                    sumSellDown += object.l[x] || 0;
                  } else {
                    count++;
                  }
                  break;
                }
                default: {
                  if (monthOfTime === month && yearOfTime === year) {
                    sumBuyUp += object.h[x] || 0;
                    sumSellDown += object.l[x] || 0;
                  } else {
                    count++;
                  }
                  break;
                }
              }
              if (count > 0) break;
            } else if (period.includes('W')) {
              const week = moment(new Date(object.t[x])).week();
              const year = new Date(object.t[x]).getFullYear();
              if (weekOfTime === week && yearOfTime === year) {
                sumBuyUp += object.h[x] || 0;
                sumSellDown += object.l[x] || 0;
              } else {
                count++;
              }
              if (count > 0) break;
            }
          }
        }
      }

      this._context.select_sym(1);
      return [
        { value: sumBuyUp || PineJS.Std.high(this._context) },
        { value: sumSellDown || PineJS.Std.low(this._context) },
      ];
    };
  },
});

export const getBUSDFromApi = async (
  symbolInfo,
  resolution,
  from,
  to,
  getIndicatorParams,
) => {
  const indicatorParams = getIndicatorParams(symbolInfo, resolution, from, to);
  if (!indicatorParams) return null;

  const { items = [] } = await chartingService
    .getIndicator(indicatorParams)
    .then(data => data);

  let maxNumber = 0;
  const data = items
    .sort((a, b) => a.tradingDate.localeCompare(b.tradingDate))
    .map(item => {
      if (Math.abs(item.bu) > maxNumber) {
        maxNumber = Math.abs(item.bu);
      }
      if (Math.abs(item.sd) > maxNumber) {
        maxNumber = Math.abs(item.sd);
      }
      return {
        tradingDate: item.tradingDate,
        highestPrice: item.bu,
        lowestPrice: item.sd,
        openPrice: 0,
        closePrice: 0,
        totalMatchVolume: 0,
      };
    });

  const [_, __, ticker] = symbolInfo.name.split(':');

  setMultiplierByCode({
    ticker,
    code: BUSDCode,
    resolution,
    maxValue: maxNumber,
    isTrillion: false,
    isBillion: false,
  });

  return { items: data };
};
